'use client';

import { StepsFlowEnum } from '@/config/steps.config';
import { BookingCountryService, BookingShop } from '@repo/common/interfaces';
import { SessionProvider } from 'next-auth/react';
import WidgetStep from './WidgetStep';
import { Session } from 'next-auth';

interface WidgetStepWrapperProps {
  countryCode: string;
  mode?: StepsFlowEnum;
  countryServices?: BookingCountryService[];
  shop?: BookingShop;
  storeId?: string;
  modelId?: string;
  superModelId?: string;
  session?: Session | null;
}

const WidgetStepWrapper = ({
  shop,
  countryServices,
  mode,
  countryCode,
  storeId,
  modelId,
  superModelId,
  session = null,
}: WidgetStepWrapperProps) => {
  return (
    <SessionProvider session={session}>
      <WidgetStep
        mode={mode}
        shop={shop}
        countryServices={countryServices}
        countryCode={countryCode}
        modelId={modelId}
        superModelId={superModelId}
        storeId={storeId}
      />
    </SessionProvider>
  );
};

export default WidgetStepWrapper;
